export * from 'react-native-localize';
